module.exports = __webpack_public_path__ + "static/shop-5edd27b7383d2ef12f58cbf006ffddc9.jpeg";